import { render, staticRenderFns } from "./EbTextarea.vue?vue&type=template&id=5a9f7c26&scoped=true"
import script from "./EbTextarea.vue?vue&type=script&lang=js"
export * from "./EbTextarea.vue?vue&type=script&lang=js"
import style0 from "./EbTextarea.vue?vue&type=style&index=0&id=5a9f7c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9f7c26",
  null
  
)

export default component.exports